import { create } from 'zustand';
import { WorkPropertyVisibleData } from '../dto/EntityRepository';

interface WorkPropertyVisibleState {
  workPropertyVisible: WorkPropertyVisibleData | null;
  setWorkPropertyVisible: (value: WorkPropertyVisibleData) => void;
  clearWorkPropertyVisible: () => void;
  setWorkPropertyVisibleEngVisibleAfterUpdate: (updated: WorkPropertyVisibleData) => void;
}

export const useWorkPropertyVisibleStore = create<WorkPropertyVisibleState>((set) => ({
  workPropertyVisible: null,
  setWorkPropertyVisible: (value) => set({ workPropertyVisible: value }),
  clearWorkPropertyVisible: () => set({ workPropertyVisible: null }),
  setWorkPropertyVisibleEngVisibleAfterUpdate: (updated) =>
    set((state) => ({
      workPropertyVisible: state.workPropertyVisible
        ? {
            ...state.workPropertyVisible,
            engVisible:
              updated.engVisible !== undefined
                ? updated.engVisible
                : state.workPropertyVisible.engVisible,
          }
        : null,
    })),
}));
